import { BundleType } from './builder-config';
import { loadScript } from './load-script';
import { PackageName } from './package-name';
import { resolveByPackageName } from './resolve-bundle';
import { scriptSource } from './script-source';

export interface LoadPackageParameters {
  packageName: PackageName;
  bundleType: BundleType;
  version?: string;
  cdn?: string;
  isLocal?: boolean;
  force?: boolean;
}

/**
 * This function will load a package if the global name it is not already present
 *
 * NOTE Loader: do not use async keyword to avoid unnecessary transpilation artifacts
 */
export function loadPackage({ packageName, bundleType, version, cdn, isLocal, force }: LoadPackageParameters) {
  const bundle = resolveByPackageName(packageName);
  if (!force && bundle) {
    return Promise.resolve();
  }

  const url = scriptSource(cdn || isLocal || false, {
    PACKAGE_NAME: packageName,
    BUNDLE_TYPE: bundleType,
    VERSION: version,
  });
  return loadScript(url);
}
